import React, { Component } from "react";
import MediaItem from "./MediaItem.js";
import BiMediaItem from "./BiMediaItem";
import InterviewMediaItem from "./InterviewMediaItem.js";

class MediaField extends Component {
  state = {
    expanded: false,
    smallMediaHeight: "0",
  };

  expand = () => {
    this.setState({ expanded: !this.state.expanded });
    if (this.state.expanded) {
      this.setState({ smallMediaHeight: "0" });
    } else {
      this.setState({ smallMediaHeight: "auto" });
    }
  };

  render() {
    return (
      <div style={staticStyle}>
        {this.props.media.map((med) => {
          if (med.text !== "") {
            if (med.englink !== undefined) {
              return <BiMediaItem media={med} />;
            } else if (med.interviewlink !== undefined) {
              return <InterviewMediaItem media={med} />;
            } else {
              return <MediaItem media={med} />;
            }
          }
        })}
      </div>
    );
  }
}

const staticStyle = {
  height: "auto",
};

export default MediaField;
